module.exports = __webpack_public_path__ + "img/couvercle.7e0c2174.jpg";